import * as Types from 'src/actions/user/changePassword/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { Data } from 'src/services/api-client/resource/base/Resource';
import ValidatorService from 'src/services/validation/Validation.service';

export interface ChangePasswordAttempt extends Action {
  type: Types.CHANGE_PASSWORD_ATTEMPT;
}

export interface ChangePasswordSuccess extends Action {
  type: Types.CHANGE_PASSWORD_SUCCESS;
}

export interface ChangePasswordFailure extends Action {
  type: Types.CHANGE_PASSWORD_FAILURE;
  payload: {};
}

export type ChangePasswordAction = ChangePasswordAttempt | ChangePasswordSuccess | ChangePasswordFailure;

export interface ChangePasswordThunk extends ThunkAction<Promise<ChangePasswordAction>, RootState, null> {
}

export const changePasswordAttempt: ActionCreator<ChangePasswordAttempt> = () => (
  {
    type: Types.CHANGE_PASSWORD_ATTEMPT
  }
);

export const changePasswordSuccess: ActionCreator<ChangePasswordSuccess> = () => (
  {
    type: Types.CHANGE_PASSWORD_SUCCESS,
  }
);

export const changePasswordFailure: ActionCreator<ChangePasswordFailure> = (error: {}) => (
  {
    type: Types.CHANGE_PASSWORD_FAILURE,
    payload: error
  }
);

export const changePassword: ActionCreator<ChangePasswordThunk> = (
  userId: number,
  newState: Data,
): ChangePasswordThunk => {

  return (dispatch: Dispatch<RootState>): Promise<ChangePasswordAction> => {
    dispatch(changePasswordAttempt());

    return ApiClient.user.updatePassword(userId, newState)
      .then((response: AxiosResponse): ChangePasswordSuccess => {

        return dispatch(changePasswordSuccess());
      }).catch((e: { response: { data: { errors: {} } } }): ChangePasswordFailure => {
        const errors = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.errors);
        
        return dispatch(changePasswordFailure(errors));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/user/changePassword/ChangePassword.actions.tsx